/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateProductTypeRequest,
  DeleteAdminV1OrgProductTypesIdPathParameters,
  GetAdminV1OrgProductTypes200,
  GetAdminV1OrgProductTypesIdPathParameters,
  PatchAdminV1OrgProductTypesIdPathParameters,
  ProductType,
  ProductTypeUpdated,
  UpdateProductTypeRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Product types of the organization with their attribute assignments
 */
export const getAdminV1OrgProductTypes = (

 options?: SecondParameter<typeof customInstance<GetAdminV1OrgProductTypes200>>,) => {
      return customInstance<GetAdminV1OrgProductTypes200>(
      {url: `/admin/v1/org/product-types`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a product type
 */
export const postAdminV1OrgProductTypes = (
    createProductTypeRequest: BodyType<CreateProductTypeRequest>,
 options?: SecondParameter<typeof customInstance<ProductType>>,) => {
      return customInstance<ProductType>(
      {url: `/admin/v1/org/product-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProductTypeRequest
    },
      options);
    }
  /**
 * @summary Get a product type
 */
export const getAdminV1OrgProductTypesId = (
    { id }: GetAdminV1OrgProductTypesIdPathParameters,
 options?: SecondParameter<typeof customInstance<ProductType>>,) => {
      return customInstance<ProductType>(
      {url: `/admin/v1/org/product-types/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Changing skuCode never rewrites existing SKUs; affectedVariantCount says how many generated SKUs still carry the old code
 * @summary Update a product type. Passing attributes replaces the whole assignment list.
 */
export const patchAdminV1OrgProductTypesId = (
    { id }: PatchAdminV1OrgProductTypesIdPathParameters,
    updateProductTypeRequest: BodyType<UpdateProductTypeRequest>,
 options?: SecondParameter<typeof customInstance<ProductTypeUpdated>>,) => {
      return customInstance<ProductTypeUpdated>(
      {url: `/admin/v1/org/product-types/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProductTypeRequest
    },
      options);
    }
  /**
 * @summary Delete a product type no product uses
 */
export const deleteAdminV1OrgProductTypesId = (
    { id }: DeleteAdminV1OrgProductTypesIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/org/product-types/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1OrgProductTypesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgProductTypes>>>
export type PostAdminV1OrgProductTypesResult = NonNullable<Awaited<ReturnType<typeof postAdminV1OrgProductTypes>>>
export type GetAdminV1OrgProductTypesIdResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgProductTypesId>>>
export type PatchAdminV1OrgProductTypesIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1OrgProductTypesId>>>
export type DeleteAdminV1OrgProductTypesIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1OrgProductTypesId>>>
